
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/music",
      function () {
        return require("private-next-pages/music/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/music"])
      });
    }
  